import { GET_SETTING } from "../constants/index";

export const setting = (
  state = { settinglist: [], settingbyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_SETTING:
      return { ...state, settinglist: action.settinglist };
    default:
      return state;
  }
};
